import { usePagination } from '../../utils';
import { Pagination } from '../Pagination/Pagination';
import s from '../../styles/staff.module.css';
import { ROLE_LABELS } from '../../constants';

export function AdminTable({ users, isLoading, isAdmin, currentUserId, onNotify, onResetPassword }) {
  const { page, pageCount, pageItems, setPage } = usePagination(users, 10);

  const canReset = (m) => isAdmin || m.idUser === currentUserId;
  const showActions = isAdmin || users.some((m) => m.idUser === currentUserId);
  const colCount = showActions ? 6 : 5;

  return (
    <div className={s.userTable}>
      <div className={s.sectionLabel}>Users ({users.length})</div>
      <div className={s.tableWrap}>
        <table className={s.table}>
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Username</th>
              <th>Email</th>
              <th>Role</th>
              {showActions && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr><td colSpan={colCount} className={s.loading}>Loading…</td></tr>
            )}
            {!isLoading && users.length === 0 && (
              <tr><td colSpan={colCount} className={s.empty}>No users yet</td></tr>
            )}
            {!isLoading && pageItems.map((m) => (
              <tr key={m.idUser}>
                <td>{m.firstName}</td>
                <td>{m.lastName}</td>
                <td>{m.username || '—'}</td>
                <td>{m.email}</td>
                <td>
                  <span className={`${s.roleBadge} ${m.role === 'admin' ? s.roleBadgeAdmin : ''}`}>
                    {ROLE_LABELS[m.role]}
                  </span>
                </td>
                {showActions ? (
                  <td>
                    <div style={{ display: 'flex', gap: 8 }}>
                      {isAdmin && (
                        <button className={s.actionBtn} onClick={onNotify(m)}>Notify</button>
                      )}
                      {canReset(m) && (
                        <button className={s.actionBtn} onClick={() => onResetPassword(m)}>Reset Password</button>
                      )}
                    </div>
                  </td>
                ) : null}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination page={page} pageCount={pageCount} onPage={setPage} />
    </div>
  );
}
